import React from 'react'

const SVG = ({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 56 56"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <circle cx="28" cy="28" r="28" fill={fill}/>
    <path 
      d="M18.8404 25.3067C17.285 23.738 14.7524 23.7272 13.1836 25.2826C11.6149 26.8381 11.6041 29.3707 13.1596 30.9394L18.8404 25.3067ZM23.8102 36L20.9697 38.8164C22.5234 40.3833 25.0524 40.3961 26.6219 38.8451L23.8102 36ZM42.8117 22.8451C44.383 21.2922 44.3979 18.7596 42.8451 17.1883C41.2922 15.617 38.7596 15.6021 37.1883 17.1549L42.8117 22.8451ZM13.1596 30.9394L20.9697 38.8164L26.6506 33.1836L18.8404 25.3067L13.1596 30.9394ZM26.6219 38.8451L42.8117 22.8451L37.1883 17.1549L20.9985 33.1549L26.6219 38.8451Z" 
      fill="white"
    />
    />
  </svg>
);

export default SVG;